import { Button, Empty } from 'antd';
import React from 'react';

import { LeashRoutes } from 'leash/utilities/const';

interface Props {
  loading: boolean;
}

export function TableEmpty({ loading }: Props) {
  if (loading) return null;

  return (
    <>
      <Empty
        image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
        imageStyle={{ height: 60 }}
        description={
          <p data-testid="empty-packages-table">Sorry! No results match your request.</p>
        }
      >
        <Button type="primary" onClick={() => (location.href = LeashRoutes.Packages)}>
          Go back
        </Button>
      </Empty>
    </>
  );
}
